var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: _vm.spanSize } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.isRequired, name: "Imóvel/Denominação" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: _vm.labelsCadastro.imovel.denominacao,
                            required: _vm.required
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: _vm.labelsCadastro.imovel.denominacao.colonia,
                            maxlength: "300"
                          },
                          model: {
                            value: _vm.imovel.denominacao,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "denominacao", $$v)
                            },
                            expression: "imovel.denominacao"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.tipoCadastro === "CANCELAMENTO_CLAUSULA_RESOLUTIVA"
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: _vm.spanSize } },
                [
                  _c("validation-provider", {
                    attrs: { rules: _vm.isRequired, name: "Imóvel/gleba" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: _vm.labelsCadastro.imovel.colonia,
                                  required: _vm.required
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  name: _vm.labelsCadastro.imovel.gleba,
                                  maxlength: "300"
                                },
                                model: {
                                  value: _vm.imovel.gleba,
                                  callback: function($$v) {
                                    _vm.$set(_vm.imovel, "gleba", $$v)
                                  },
                                  expression: "imovel.gleba"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      403337321
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: _vm.spanSize } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.isRequired, name: "Imóvel/Município" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Município:", required: _vm.required }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              "no-match-text": "Nenhum Município Encontrado",
                              placeholder: "Selecione",
                              filterable: "filterable",
                              clearable: "clearable",
                              "value-key": "id",
                              name: "Município"
                            },
                            on: {
                              clear: function($event) {
                                _vm.imovel.municipio = null
                              }
                            },
                            model: {
                              value: _vm.imovel.municipio,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "municipio", $$v)
                              },
                              expression: "imovel.municipio"
                            }
                          },
                          _vm._l(_vm.municipios, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.nome, value: item }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: _vm.spanSize } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.isRequiredArea, name: "Imóvel/Área" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Área:", required: _vm.required }
                        }),
                        _c("app-double-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "Área",
                            precision: 4,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true
                          },
                          on: {
                            areaString: function($event) {
                              return _vm.areaChange($event)
                            }
                          },
                          model: {
                            value: _vm.imovel.area,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "area", $$v)
                            },
                            expression: "imovel.area"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.tipoCadastro === "INFORMACOES"
        ? _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.isRequired,
                          name: "Imóvel/Nome da Colônia"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: _vm.labelsCadastro.imovel.colonia,
                                      required: _vm.required
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      maxlength: "300",
                                      name: _vm.labelsCadastro.imovel.colonia
                                    },
                                    model: {
                                      value: _vm.imovel.nomeColonia,
                                      callback: function($$v) {
                                        _vm.$set(_vm.imovel, "nomeColonia", $$v)
                                      },
                                      expression: "imovel.nomeColonia"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          935529632
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: _vm.isRequired,
                          name: "Imóvel/Localização"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Localização:",
                                      required: _vm.required
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      name: "Localização",
                                      type: "textarea",
                                      rows: 5
                                    },
                                    model: {
                                      value: _vm.imovel.localizacao,
                                      callback: function($$v) {
                                        _vm.$set(_vm.imovel, "localizacao", $$v)
                                      },
                                      expression: "imovel.localizacao"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2823053787
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a4937b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a4937b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppImovelDenominacao.vue
// module id = null
// module chunks = 